/** This file is converted from less to scss */
@use '@dixa/lib-shared-tokens/scss' as *;
$avatarSize: 32px;

.avatarRow {
  margin-bottom: var(--dixa-size-spacer-300);
}
.avatarRowButton {
  margin-right: var(--dixa-size-spacer-200);
}

.avatarPhotoHolder {
  position: relative;
  height: $avatarSize;
  width: $avatarSize;
  margin-right: var(--dixa-size-spacer-200);
  float: left;
  display: block;
}

.avatarPhoto {
  position: relative;
  background: repeating-conic-gradient(
      var(--dixa-color-neutral-200) 0% 25%,
      transparent 0% 50%
    )
    50% / 8px 8px;
  height: inherit;
  width: inherit;
  overflow: hidden;
  border-radius: var(--dixa-size-border-radius-100);
  z-index: 3;
  float: left;

  input[type='file'] {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 9;
  }

  &:hover {
    .avatarEdit {
      background-color: color-mix(
        in srgb,
        var(--dixa-color-neutral-900) 40%,
        transparent
      );
    }

    .icon {
      opacity: 1;
    }
  }
}

.avatarEdit {
  text-align: center;
  background: transparent;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
  position: absolute;
  transition: all 0.8s ease;

  .icon {
    transition: all 0.3s ease;
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    opacity: 0;
    color: var(--dixa-color-neutral-000);
  }

  &:hover {
    background-color: color-mix(
      in srgb,
      var(--dixa-color-neutral-900) 40%,
      transparent
    );
  }
}
